import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { SearchHeaderComponent } from '../search-header/search-header.component';
import { DropdownComponent } from '@woolworthsnz/form';
import { EmbeddedVisibilityDirective } from '@woolworthsnz/styleguide';
import { SearchPaginationComponent } from '../search-pagination/search-pagination.component';
import { NgIf, AsyncPipe } from '@angular/common';

@Component({
	selector: 'search-legacy-header',
	templateUrl: './legacy-search-header.component.html',
	styleUrls: ['./legacy-search-header.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: true,
	imports: [EmbeddedVisibilityDirective, NgIf, SearchPaginationComponent, DropdownComponent, AsyncPipe]
})
export class LegacySearchHeaderComponent extends SearchHeaderComponent {
	@Input() currentPageSize: number;
	@Input() currentPage: number;
	@Input() itemsPerPageCollection: string[];
}
